/**
 * Placeholder body copy per module key. Each module's real screens arrive
 * phase by phase from the Figma walkthrough (Phase 1 Hub, Phase 2 AirSensors,
 * Phase 3 Windows, Phase 4 Floor heating, Phase 5 Ventilation).
 */
export const STEP_CONTENT: Record<string, string> = {
  home_assistant:
    "Plug in the SmartClimate Hub and connect it to your network. We'll link it to your home remotely.",
  air_sensors: "Place the air quality sensors in the recommended rooms and activate them.",
  floor_heating: "Connect the gateway to your floor heating system.",
  ventilation: "Connect the gateway to your ventilation unit.",
  windows: "Pair your VELUX windows with the system.",
};
